export function luhnValidate(code: string) {
  const len = code.length
  const parity = len % 2
  let sum = 0
  for (let i = len - 1; i >= 0; i--) {
    let d = parseInt(code.charAt(i))
    if (i % 2 === parity) {
      d *= 2
    }
    if (d > 9) {
      d -= 9
    }
    sum += d
  }
  return sum % 10 === 0
}

export function isSiret(value?: string): value is string {
  if (!value) return false
  if (value.length !== 14) return false
  if (value.endsWith('00000')) return false

  return luhnValidate(value)
}

export function isSiren(value?: string): value is string {
  if (!value) return false
  if (value.length !== 9) return false
  if (value.endsWith('00000')) return false

  return luhnValidate(value)
}
